import { AnimatePresence } from 'framer-motion'
import { useEffect, useRef } from 'react'

import type { IFindingItem } from '@/hooks/useReportData'

import { FindingItem } from './FindingItem'

interface FindingsPanelProps {
  findings: IFindingItem[]
}

export function FindingsPanel({ findings }: FindingsPanelProps) {
  const scrollRef = useRef<HTMLDivElement>(null)
  const isUserInteractingRef = useRef(false)

  useEffect(() => {
    if (scrollRef.current && !isUserInteractingRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [findings.length])

  if (findings.length === 0) return null

  const reversed = [...findings].reverse()

  return (
    <div
      ref={scrollRef}
      onPointerEnter={() => {
        isUserInteractingRef.current = true
      }}
      onPointerLeave={() => {
        isUserInteractingRef.current = false
      }}
      className="h-full overflow-y-auto py-4 px-2 space-y-2 scrollbar-hidden"
    >
      <AnimatePresence initial={false}>
        {reversed.map((item) => (
          <FindingItem key={item.id} item={item} />
        ))}
      </AnimatePresence>
    </div>
  )
}
